<template>
    <div class="border-b border-gray-700 pb-2">
      <div
        @click="toggle"
        class="cursor-pointer font-semibold py-2 flex justify-between items-center text-white"
      >
        <span>{{ title }}</span>
        <span>{{ isOpen ? '▲' : '▼' }}</span>
      </div>
      <transition name="fade">
        <div v-show="isOpen" class="pl-2 text-sm pt-1">
          <slot name="content" />
        </div>
      </transition>
    </div>
</template>
  
  <script>
  export default {
    name: 'BaseAccordionItem',
    props: {
      title: String,
    },
    data() {
      return {
        isOpen: true, // 默认展开
      };
    },
    methods: {
      toggle() {
        this.isOpen = !this.isOpen;
      },
    },
  };
  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
    max-height: 0;
  }
  </style>
  